import axios from 'axios'
import { getToken } from "@/services/auth";

const $axios = axios.create({
    baseURL: 'https://protos-trading-api.herokuapp.com/',
})

$axios.interceptors.request.use(
    (requestConfig) => {
        const token = getToken()
        requestConfig.headers.Authorization = token ? `Bearer ${token}` : ''
        return requestConfig
    },
)

export { $axios }
